<template>
<!--  ivu-select-visible -->
  <div ref = 'rangeBox' :class = "{'ivu-select-visible':selectShow}" class='range ivu-select ivu-select-single ivu-select-default'>
    <div tabindex="0" class="ivu-select-selection" @click.stop = "_select">
      <input type="hidden"> 
      <div class="">
        <div  v-if = 'rangeValue' style = 'padding-left:10px;line-height:30px; overflow:hidden;text-overflow:ellipsis;white-space:nowrap'>
          <span style = "padding-right:5px;">{{title}}:</span>
          <span>{{(this.value.min||this.value.min === 0)?this.value.min: forms.value1}}</span>
          <span style = "padding-left:5px;">{{unit}}</span>
          <span style = "padding:0 5px;">~</span>
          <span>{{(this.value.max||this.value.max === 0)?this.value.max: forms.value2}}</span>
          <span style = "padding-left:5px;">{{unit}}</span>
        </div>
        <span v-else class="ivu-select-placeholder">{{this.placeholder || "请输入"}}</span> 
        <i class="ivu-icon ivu-icon-ios-arrow-down ivu-select-arrow"></i>
      </div>
    </div>
    <div @click.stop ref = 'selectDown' :style = "styles" v-if = "selectShow" class = "selectDown ivu-select-dropdown ivu-select-dropdown-transfer">
      <div style = "padding-bottom:5px;padding-left: 10px;">请输入{{title}}范围</div>
      <Form ref="formInline" :model="forms" :rules="ruleInline" inline>
      <div style = "display:flex;position:relative;padding-left: 10px;">
        <span style = "position:absolute;z-index:10;font-size:12px;top:10px;left:100px;">{{this.unit}}</span>
        <span style = "position:absolute;z-index:10;font-size:12px;top:10px;right:-10px;">{{this.unit}}</span>
        <FormItem prop="value1" :show-message = "false" style="width: 90px;margin:0;">
          <Input type = "number" v-model = "forms.value1" size = "small" style="width: 90px" />
        </FormItem>
        <span style = "display:inlin-block;flex:1;text-align:center;line-height:24px;">~</span>
        <FormItem prop="value2" :show-message = "false" style="width: 90px;margin:0;">
          <Input type = "number" v-model = "forms.value2" size = "small" style="width: 90px" />
        </FormItem>
      </div>
      </Form>
      <div style = "text-align:right;padding-top:20px;">
          <Button style = "margin-right:10px;" @click = "_cancel">取消</Button>
          <Button type="primary" @click = "_selectVal">确定</Button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    unit: String,//单位
    title: String,//标题
    placeholder: String,
    value: Object
  },
  data(){
    return {
      selectShow: false,
      rangePos: [],
      forms: {
        value1: '',
        value2: '',
      },
      ruleInline: {
            value1: [
                { required: true, message: '', trigger: 'blur' }
            ],
            value2: [
                { required: true, message: '', trigger: 'blur' }
            ]
        }
    }
  },
  computed: {
    rangeValue(){
      if(this.value&&(this.value.min||this.value.min===0)&&(this.value.max||this.value.max===0)){
        return true
      }else{
        return ""
      }
    },
    styles(){
      return {
        // top: (this.rangePos[0]+30)+ "px"
      }
    }
  },
  created(){
    console.log('112',this.value);
  },
  mounted() {
    document.addEventListener('click',() => {
      this.selectShow = false;
    })
  },
  watch: {
    value(val){
      if(val){
        if(val.min||val.min == 0){
          this.forms.value1 = val.min;
        }
        if(val.max||val.min == 0){
          this.forms.value2 = val.max;
        }
      }
    }
  },
  methods:{
    _select(){
      this.rangePos = getPosition(this.$el)
      this.selectShow = !this.selectShow;
      this.$nextTick(()=>{
        this.$refs['selectDown']&&(this.$refs['selectDown'].style.marginTop = -document.querySelector('.scmcc-layout-frame-content').scrollTop + 'px')
        this.$refs['selectDown']&&(this.$refs['selectDown'].style.width = this.$refs['rangeBox'].offsetWidth + 'px')
      })
    },
    _cancel(){
      if(this.value){
        this.forms.value1 = this.value.min?this.value.min:'';
        this.forms.value2 = this.value.max?this.value.max:'';
      }
      this.selectShow = false;
    },
    _selectVal(){
      if(!this.value){
        this.value = {};
      }
      this.value.min = this.forms.value1;
      this.value.max = this.forms.value2;
      this.selectShow = false;
      this.$emit("change",{
        min: this.forms.value1,
        max: this.forms.value2
      })
    }
  },
  components: {}
}
//获取绝对位置
function getPosition(el,position){
    if(!position){
        position = [0,0];
    }
    position[0] +=  el.offsetLeft;
    position[1] += el.offsetTop;
    if(el.offsetParent){
        return getPosition(el.offsetParent,position);
    }else{
        return position;
    }
}
</script>
<style scoped lang = "less">
.range{
  position:relative;
  height:32px;
  width: 100%;
  /* width:220px; */
  margin-bottom:0!important;
  .selectDown{
    position:fixed; 
    /* position:absolute; */
    min-width:220px!important;
    padding:10px;
    z-index:9999;
  }
  
}
</style>